import React from "react";

import { useIntl } from "react-intl";

import styles from "./Description.module.scss";

interface Props {}

const Description: React.FC<Props> = () => {
  const intl = useIntl();
  return (
    <section className={styles.container}>
      <span>
        {intl.formatMessage({
          id: "billing.licenses.description",
          defaultMessage:
            "Licenses can be transferred to other team members once purchased and you can add additional licenses at anytime.",
          description: "Description of the Licenses item card on Billing",
        })}
      </span>
      <a href="https://www.mapmycustomers.com/pricing" rel="noopener noreferrer" target="_blank">
        {intl.formatMessage({
          id: "billing.licenses.moreInfo",
          defaultMessage: "Explore Pricing",
          description: "Explore Pricing link of the Licenses item card on Billing",
        })}
      </a>
    </section>
  );
};

export default Description;
